import { useSelector } from 'react-redux';
import { config } from '../config';

export const useAuthMethods = () => {
  const country = useSelector((state) => state.app.country);

  return config.app.authMethods[country] || [];
};
